export enum EStatutRapportParcours {
  NonDemarre = 0,
  EnCours = 1,
  Complete = 2,
  ARefaire = 3
}

export interface RapportParcoursFormationStatsModel {
  nombreParcours: number;
  totalFormations: number;
  utilisateursVises: number;
  pourcentageCompleteMoyen: number;
  pourcentageAvancementMoyen: number;
  utilisateursARefaire: number;
}

export interface RapportParcoursFormationLigneModel {
  parcoursFormationId: number;
  nomOrganisation: string;
  nom: string;
  nbreContenus: number;
  nbreUtilisateursVises: number;
  nbreUtilisateursAyantComplete: number;
  nbreContenusCompletes: number;
  nbreContenusTotal: number;
  pourcentageComplete: number;
  pourcentageAvancement: number;
  nbreUtilisateursARefaire: number;
  estRecurrent: boolean;
  recurrenceEnAnnees: number | null;
}

export interface RapportParcoursFormationResponse {
  stats: RapportParcoursFormationStatsModel;
  lignes: RapportParcoursFormationLigneModel[];
}

export interface RapportUtilisateurParcoursStatsModel {
  utilisateursUniques: number;
  assignationsTotales: number;
  completes: number;
  enCours: number;
  aRefaire: number;
  nonDemarres: number;
}

export interface RapportUtilisateurParcoursLigneModel {
  utilisateurId: number;
  nomUtilisateur: string;
  etiquettes: string[];
  parcoursFormationId: number;
  nomOrganisation: string;
  nomParcours: string;
  estRecurrent: boolean;
  recurrenceEnAnnees: number | null;
  statut: EStatutRapportParcours;
  contenusCompletes: number;
  totalContenus: number;
  dureeVisionneeMinutes: number;
  dureeTotaleMinutes: number;
  pourcentageProgression: number;
  estUtilisateurActif: boolean;
}

export interface RapportUtilisateurParcoursResponse {
  stats: RapportUtilisateurParcoursStatsModel;
  lignes: RapportUtilisateurParcoursLigneModel[];
}

export interface RapportContenuParcoursStatsModel {
  assignationsTotales: number;
  contenusUniques: number;
  completes: number;
  enCours: number;
  aRefaire: number;
  nonDemarres: number;
  noteMoyenne: number | null;
}

export interface RapportContenuParcoursLigneModel {
  scormPackageId: number;
  nomContenu: string;
  dureeMinutes: number | null;
  utilisateurId: number;
  nomUtilisateur: string;
  etiquettes: string[];
  parcoursFormationId: number;
  nomOrganisation: string;
  nomParcours: string;
  estRecurrent: boolean;
  recurrenceEnAnnees: number | null;
  statut: EStatutRapportParcours;
  dateDerniereCompletion: string | null;
  note: number | null;
  estCertificat: boolean;
  sessionId: number | null;
  estUtilisateurActif: boolean;
}

export interface RapportContenuParcoursResponse {
  stats: RapportContenuParcoursStatsModel;
  lignes: RapportContenuParcoursLigneModel[];
}
